// Sys/Color/Surface/Neutral/500
import {
  CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT,
  CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_LIGHT,
  SEM_COLOR_UI_FOREGROUND_TEXT_DEFAULT_LIGHT,
  GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT,
  SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT,
  SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT,
  SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT,
  SYS_SPACE_FIXED_300,
  SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_200_LIGHT,
} from '@oneaudi/unified-web-common';
import type { CustomTheme } from '../@types/theme';

const colors = {
  colorCanvasDefault: GLOBAL_COLOR_CANVAS_DEFAULT_LIGHT,
  defaultTextColor: SEM_COLOR_UI_FOREGROUND_TEXT_DEFAULT_LIGHT,
  badgeTextColor: SYS_COLOR_FOREGROUND_NEUTRAL_800_LIGHT,
  badgeNewBgColor: SYS_COLOR_SURFACE_HIGHLIGHT_PRIMARY_LIGHT,
  badgeTypeBgColor: SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT,
  surfaceNeutral700: SYS_COLOR_SURFACE_NEUTRAL_700_LIGHT,
  tagSelectedBgColor: CMP_COLOR_UI_TAG_SELECTED_SURFACE_FILL_DEFAULT_LIGHT,
  tagUnselectedBgColor: CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_FILL_DEFAULT_LIGHT,
  filterCategoryUnselectedTextColor: SYS_COLOR_FOREGROUND_INTERACTIVE_PRIMARY_200_LIGHT,
  dividerBgColor: SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
  dividerSelectedBgColor: SYS_COLOR_SURFACE_INTERACTIVE_PRIMARY_100_LIGHT,
};

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

const spacing = {
  fixed300: SYS_SPACE_FIXED_300,
};

export const lightTheme: CustomTheme = {
  name: 'light',
  colors,
  breakpoints,
  spacing,
};
